export default {
    email: 'Courriel',
    phone: 'Téléphone',
    sms: 'SMS',
    messenger: 'Messenger',
    video: 'Vidéo',

    asAction: {
        email: 'courriel {type}',
        phone: 'appel {type}',
        sms: 'texto {type}',
        messenger: 'message Facebook {type}',
        video: 'appel vidéo {type}',
    },

    asOutgoingAction: {
        email: 'Courriel sortant',
        phone: 'Appel sortant',
        sms: 'Texto sortant',
        messenger: 'Message Facebook sortant',
        video: 'Appel vidéo sortant',
    },
};
